import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Modal, Table} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';
import Notifications, {notify} from 'react-notify-toast';
import MaskedFormControl from 'react-bootstrap-maskedinput';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {Typeahead} from 'react-bootstrap-typeahead';
import Parser from 'html-react-parser';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import SvgIcon from 'react-icons-kit';
import {pencilSquareO} from 'react-icons-kit/fa/pencilSquareO';
import {bin} from 'react-icons-kit/icomoon/bin';
import {clipboard} from 'react-icons-kit/icomoon/clipboard';

var Config = require('../../../config');

class ModalInfo extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.getTableUnits = this.getTableUnits.bind(this);

		this.state = {
			show: false,
			id:"",
			patient_name			:"",
			patient_lastname1		:"",
			patient_lastname2		:"",
			birthdate		:"",
			age				:"",
			age_type 		:"YEARS",
			lookup_group	:"",
			lookup_rh		:"",
			documents		:[],
			document_type	:"DOCUMENT_INE",
			document_number	:"",
			social_number 	:"",
			clinic_history 	:"",

			petitions		:[],
			petition 		:"",
			type_petitions  :[],
			petition_type	:"",


			loading_patient :false,
			patient_list	:[],
			patient_id		:"",
	     	person_id		:"",
			disableFields	:false,

			samples 		:[],

			clinic_history_list :[],

			plasmatic_products	:[],


			date 		  	: "",
			hour 		  	: "",
			petition_number	: "",
			
			petition_episodio 	 :"",
			petition_ubication	 :"",
			petition_doctor		 :"",
			petition_observations:"",
			petition_diagnosis   :"",
			reasons 			 :[],
			petition_reason 	 :"",

			plasmatic_product_id:"",
			plasmatic_product_amount:"",
			plasmaticAdded:[],
			loading_product:false,
			product_selected:[],
			index_product:-1,
			valid_prod:"",

			
			health_facilities     :[],
			origin_center_id:"",

			facility_sections	  :[],
			health_services	  :"",
			
			maternal_test_id:"",
			maternal_test_ultima_regla	 	:"",
			maternal_test_gestational_week 	:"",
			maternal_test_gestational_day	:"",
			maternal_test_expected_birthday	:"",
			maternal_test_no_fetus		 	:"",
			maternal_test_profilaxis 		:"",
			maternal_test_profilaxis_date	:"",
			maternal_test_child_alive		:"",
			maternal_test_child_dead		:"",
			maternal_test_abortions		 	:"",

			petition_components:[],
			
			solicited_date: "",
			solicited_hour: "",

			previous_transfutions:[],
			previous_transfutions_name:"",
			petition_previal_transfution:"",

			petition_consentimiento:"",
			petition_component_priority:"",
			petition_component_surgery_type:"",

			analitical_profiles:[],
			analitical_profile_person_id:[],
			petition_study_id:"",
			petition_study1:"",

			petition_aferesis:[],
			process_type:"", 
			process_type_id:"",
			solicitud_type:"",

			blood_components:[],
			blood_component_type:"",
			blood_component_amount:"",
			componentsAdded:[],

			isLoading:false,
			analitical_list: [],
			profile_list: [],
			
			list_test:[],
			list_profile:[],
			test:"",
			profile:"",
			index_profile:"",
			view_samples:false,

			sample_id:"",
			indice:-1,
			requestedSelected:[],
			profile_selected:[],
			pat_pol_trans:"NO",

			politransfused:false,
			cant_change:false,

			last_unit_date:"",
			unit_reserved:"",
			phenotypes:"",
			special_patient:[],
			special_values:[],
			patient_sex:"",
			lectina:"",
			du:"",
			check_age:false,
			flag_samples:"",

			doctor_lastname1:"",
			doctor_lastname2:"",
			cedula_doctor:"",
			petition_status:"",

			pat_diag_type:{},
			list_diagnosis:[],
			character_observa:'500',
			pet_fam_res:{},

			petition_family_responsable:{},
			work_sessions:[],
			work_sessions_id:"",
			have_samples:false,
			sample_selected_id:"",
			antibodys:"",
			list_unit_reserved:[],
			list_unit_delivered:[],
			last_date_send:"",
			petition_history:[],
			hide_patient:false,
			list_components:[],
			sol_mul_comp:{},
			pat_change_date_petition:{}
		}

	}

	componentWillMount(){
		this.props.onRef(this);

		
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(id){
		this.specialFields(0, 1);

		this.getTableUnits(id);

		fetch(Config.default.apiGateway.URL+'work_sessions/'+sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      work_sessions: response
		    });
		})

		fetch(Config.default.apiGateway.URL+'petition_type?option=active', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){
				this.setState({petitions:response});
			}
		});

		fetch(Config.default.apiGateway.URL+'lookups/order_by?type=petition_group_types&option=name', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({type_petitions:response});
			}
		});

		fetch(Config.default.apiGateway.URL+'national_centers?option=origin_patients', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({health_facilities:response});
			}
		});

		fetch(Config.default.apiGateway.URL+'lookups?type=PROCESS_TYPE_PATIENTS&option=actives&order=false', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({petition_aferesis:response});
			}
		});

		fetch(Config.default.apiGateway.URL+'lookups?type=PATIENTS_REASONS&option=actives&order=false', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({reasons:response});
			}
		});

		fetch(Config.default.apiGateway.URL+'analytic_profile_person?option=patients', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({analitical_profiles:response});
			}
		});

		fetch(Config.default.apiGateway.URL+'lookups?type=blood_component_type&option=actives&order=false', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					blood_components: response
				});
			}
		});

		this.getCriterial();
		this.getDocuments();

		this.getServices();

		this.props.waiting.handleShow('Cargando...');
	
		setTimeout(()=>{
			this.getPlasmaticProduct();
		}, 500);
		
		fetch(Config.default.apiGateway.URL+'petitions?id='+id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){
				this.setState({id:id, show: true, disabledFields:true});

				setTimeout(()=>{

					var index = this.state.petitions.findIndex(obj =>
						obj.id === response.petition.petition_type_id
					);

					this.getPetition(this.state.petitions[index].name);
					
					if(this.state.petitions[index].type === 'COMPONENTS'){
						this.setState({petition:'COMPONENTS'});
						this.clearValues();
						this.getPetitionType('COMPONENTS');
						
					}else if(this.state.petitions[index].type === 'APHERESIS'){
						this.setState({petition:'APHERESIS'});
						this.getPetitionType('APHERESIS');
						this.clearValues();
					}else if(this.state.petitions[index].type === 'PLASMATIC_PRODUCTS'){
						this.clearValues();
						this.setState({petition:'PLASMATIC_PRODUCTS'});
						this.getPetitionType('PLASMATIC_PRODUCTS');
						
					}else{
						this.setState({petition:'LABORATORY'});
						this.getPetitionType('LABORATORY');
						this.clearValues();
						this.getAnaliticalTest();
						this.getAnaliticalProfile();
						if(this._typeahead_test !== undefined && this._typeahead_test !== null){
							if(this._typeahead_test.getInstance() !== null){
								this._typeahead_test.getInstance().clear();
							}
						}
						if(this._typeahead_profile !== undefined && this._typeahead_profile !== null){
							if(this._typeahead_profile.getInstance() !== null){
								this._typeahead_profile.getInstance().clear();
							}
						}
					}

					this.setState({
						patient_id: response.patient.id,
						person_id:response.person.id,
						patient_name: response.person.names,
						patient_lastname1: response.person.lastname1,
						patient_lastname2: response.person.lastname2,
						clinic_history: response.petition.clinic_history,
						social_number: response.person.social_number,
						disableFields: true,
						lookup_group: response.person.lookup_group,
						lookup_rh: response.person.lookup_rh,
						document_type: response.documents.length > 0 ? response.documents[0].document_type : "",
						document_number: response.documents.length > 0 ? response.documents[0].document_number : "",
						birthdate: response.person.birthday !== null ? moment(response.person.birthday).format('DD/MM/YYYY') : '',
						age:response.patient_age,
						age_type:response.petition.age_type,
						patient_sex:response.person.sex,
						lectina:response.lectina,
						du:response.du,
						doctor_lastnames: response.petition.doctor,
						cedula_doctor:response.petition.cedula_medico,
						petition_status:response.petition.status
					})

					if(response.person.birthday !== null){
						var control = document.getElementById('birthdate');
						//this.petition.calcularEdad(response.person.birthday, control);
					}

					var phen = '';
					response.phenotype.map((p, i)=>{
						phen += p.phenotype1+p.result+( i === response.phenotype.length -1 ? '' : ', ')
					})

					this.setState({phenotypes: phen});

					this.specialFields(0, 1);
	
					setTimeout(()=>{
						this.setState({
							special_values: response.special_fields_values
						});

						this.setAnswers(response.special_fields_values)
					}, 500);
						
					this.setState({
						petition_id: response.petition.id,						
						date: response.petition.petition_date !== null ? 
							moment(response.petition.petition_date, 'YYYY-MM-DD').format('YYYY-MM-DD') : "",
						hour: response.petition.petition_hour !== null ? 
							moment(response.petition.petition_hour, 'HH:mm:ss').format('HH:mm') : "",
						petition_number: response.petition.petition_number !== "" ? response.petition.petition_number : "",
						petition_episodio: response.petition.episodio !== null ? response.petition.episodio : "",
						petition_ubication: response.petition.ubication !== "" ? response.petition.ubication : "",
						petition_doctor: response.petition.doctor !== "" ? response.petition.doctor : "",
						petition_component_priority: response.petition.priority !== null ? response.petition.priority : "",
						solicited_date: response.petition.pickup_date !== null ? moment(response.petition.pickup_date.split('T')[0]).format('YYYY-MM-DD') : "",
						petition_diagnosis: response.petition.diagnosis !== null ? response.petition.diagnosis : "",
						petition_observations: response.petition.observations !== "" ? response.petition.observations : "",
						//origin_center_id: response.petition.origin_center_id,
						health_services: response.petition.health_services,
						petition_reason: response.petition.reason !== null ? response.petition.reason : "",
						petition_consentimiento: response.petition.consentimineto_informado !== null ? response.petition.consentimineto_informado : "",
						petition_previal_transfution: response.petition.previal_transfution,
						flag_samples:response.flag_samples,
						//doctor_lastnames:response.petition.doctor_lastname1+' '+response.petition.doctor_lastname2,
						cedula_doctor:response.petition.cedula_medico,
						petition_status:response.petition.status
					});

					if(response.petition.previal_transfution !== null && response.petition.previal_transfution !== "" && response.petition.previal_transfution !== "NO"){
						document.getElementById('petition_previal_transfution').checked = true;
					}

					if(response.petition.consentimineto_informado !== null && response.petition.consentimineto_informado !== "" && response.petition.consentimineto_informado !== "NO"){
						document.getElementById('petition_consentimiento').checked = true;
					}

					if(response.petition.origin_center_id !== undefined){
						var index = this.state.health_facilities.findIndex(obj => 
							obj.id === response.petition.origin_center_id
						);
						if(index !== -1){
							this.setState({
								indice: 0,
								requestedSelected:[this.state.health_facilities[index]],
								origin_center_id: response.petition.origin_center_id,
							})
						}
					}

					if(response.maternal_test.length > 0){
						this.setState({
							maternal_test_id: response.maternal_test[0].id,
							maternal_test_ultima_regla: response.maternal_test[0].ultima_regla !== null ?
														moment(response.maternal_test[0].ultima_regla).format('YYYY-MM-DD') : "",
							maternal_test_gestational_week: response.maternal_test[0].gestational_week || "",
							maternal_test_gestational_day: response.maternal_test[0].gestational_day || "",
							maternal_test_expected_birthday: response.maternal_test[0].expected_birth || "",
							maternal_test_no_fetus: response.maternal_test[0].no_fetus || "",
							maternal_test_profilaxis: response.maternal_test[0].prophylaxis ? 'SI' :
														!response.maternal_test[0].prophylaxis ? 'NO' : "",
							maternal_test_profilaxis_date: response.maternal_test[0].prophylaxis_date !== null ?
														 response.maternal_test[0].prophylaxis_date.split('T')[0] : "",
							maternal_test_child_alive: response.maternal_test[0].child_alive || '0',
							maternal_test_child_dead: response.maternal_test[0].child_dead !== 0 ? response.maternal_test[0].child_dead : '0',
							maternal_test_abortions: response.maternal_test[0].abortions !== 0 ? response.maternal_test[0].abortions : '0',
						});
					}

					response.petition_aferesis.map((af)=>{
						var index = this.state.petition_aferesis.findIndex(obj => obj.key === af.process_type);
						
						if(index !== -1){
							this.setState({
								process_type_id: af.id,
								process_type: this.state.petition_aferesis[index].key
							});
						}
							
					});

					response.petitions_blood_components.map((comp)=>{
						this.setState({
							petition_components: [
								...this.state.petition_components, {
									id: comp.id,
									petitions_id: comp.petitions_id,
									amount: comp.amount,
									component_type: comp.component_type,
									informed_consent: comp.informed_consent,
									previous_transfusions: comp.previous_transfusions,
									priority: comp.priority,
									solicitedfor_date: comp.solicitedfor_date,
									solicitedfor_hour: comp.solicitedfor_hour,
									surgery_type: comp.surgery_type,
								}
							]
						});

						if(comp.solicitedfor_hour !== "" && comp.solicitedfor_hour !== null){
							this.setState({
								solicited_hour: moment(comp.solicitedfor_hour, 'h:mm').format('h:mm')
							});
								
						}
					});

					response.petition_products.map((prod)=>{
						
						var index = this.state.plasmatic_products.findIndex(obj => obj.id === prod.plasmatic_product_id);
					
						if(index !== -1){
							this.setState({
								plasmaticAdded: [
									...this.state.plasmaticAdded, {
										id_plasmatic: prod.id,
										id: this.state.plasmatic_products[index].id,
										name: this.state.plasmatic_products[index].name,
										amount: prod.amount
									}
								]
							});
						}
					});

					response.petition_study.map((pet)=>{
						return this.setState({
							analitical_profile_person_id:pet.analytic_profile_person_id,
							petition_study_id:pet.id,
							petition_study1:pet.petition_study1
						});
					});

					//this.petition.getAnaliticalTest();
					//this.petition.getAnaliticalProfile();
					setTimeout(()=>{
						response.petition_lab.map((lab)=>{
							if(lab.analitical_test_id && lab.analytic_profile_person_id === null){
								this.setState({
									solicitud_type: 'PRUEBA'
								});
								
							}else if(lab.analytic_profile_person_id !== null){
								this.setState({
									solicitud_type: 'PERFIL'
								});

								
							}

							var index_test = this.state.analitical_list.findIndex(obj => obj.analitical_test.id === lab.analitical_test_id);
							var index_profile = this.state.profile_list.findIndex(obj => obj.profile.id === lab.analytic_profile_person_id);
							
							if(index_test !== -1){
								this.setState({
									list_test: [
										...this.state.list_test,
										{
											id: lab.analitical_test_id,
											lab_id: lab.id,
											petition_id: lab.petition_id,
											name: this.state.analitical_list[index_test].analitical_test.name,
											check: true
										}
									],
								});
							}
							
							if(index_profile !== -1){
								/*this.petition.setState({
									index_profile: index_profile
								});*/
								this.setState({
									index_profile: 0,
									profile_selected:[this.state.profile_list[index_profile]]
								})
							}	
						});
					}, 500);



				}, 500);
			}
		})
	}

	getTableUnits(id){
		fetch(Config.default.apiGateway.URL+'petitions/table_units?id='+id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					list_components: response
				});					
			}
		});
	}

	handleClose(){
		this.setState({
			show:false,
			petition_number	: "",
			petition_id: "",
			petition_episodio 	 :"",
			petition_ubication	 :"",
			petition_doctor		 :"",
			petition_observations:"",
			petition_diagnosis   :"",
			petition_reason 	 :"",

			plasmatic_products: [],
			plasmatic_product_id:"",
			plasmatic_product_amount:"",
			
			origin_center_id:"",

			health_services	  :"",
			
			maternal_test_ultima_regla	 	:"",
			maternal_test_gestational_week 	:"",
			maternal_test_gestational_day	:"",
			maternal_test_expected_birthday	:"",
			maternal_test_no_fetus		 	:"",
			maternal_test_profilaxis 		:"",
			maternal_test_profilaxis_date	:"",
			maternal_test_child_alive		:"",
			maternal_test_child_dead		:"",
			maternal_test_abortions		 	:"",

			petition_components:[],
			
			solicited_date: "",
			solicited_hour: "",

			previous_transfutions:[],
			previous_transfutions_name:"",
			petition_previal_transfution:"",

			petition_consentimiento:"",
			petition_component_priority:"",
			petition_component_surgery_type:"",

			analitical_profile_person_id:"",
			process_type:"", 
			solicitud_type:"",

			blood_component_type:"",
			blood_component_amount:"",
			componentsAdded:[],

			isLoading:false,
			analitical_list: [],
			list_test:[],
			test:"",
			profile:"",
		})
	}

	specialFields(donor, patient){
  		
  		fetch(Config.default.apiGateway.URL+'CamposEspeciales?health_facilities_id='+
  			sessionStorage.getItem('health_facilities_id')+'&for_donors='+donor+'&for_patients='+patient,{
  			method:'get',
  			headers: new Headers({
  				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
  				'Accept'		: 'application/json',
  				'Content-Type'	: 'application/json'
  			})
  		}).then(res => {
  			if(res.ok){
  				return res.json();
  			}else{
  				res.text().then((msg)=>{
  					swal('Error', msg, 'error');
  				});
  			}
  		}).then(response => {
  			if(response !== undefined){
  				if(patient === 1){
  					this.setState({
  						special_patient: response
  					});
  				}else{
  					this.setState({
  						special_donor: response
  					});
  				}
  			}
  		});
  	}

	getCriterial(){
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PAT_POL_TRANS&x=', {
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		}).then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
          	}
      	}).then(response => {
      		if(response !== undefined){
      			this.setState({pat_pol_trans:response.value});      					
      		}
      	});
	}

	getDocuments(){
		fetch(Config.default.apiGateway.URL+'lookups?type=document_type&notrender=0',{
			method: 'get',
			headers: new Headers({
			   	'Authorization' : 'Bearer ' + sessionStorage.getItem("token") , 
			   	'Accept' 		: 'application/json',
				'Content-Type' 	: 'application/json',
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response=>{
			if(response !== undefined){
				this.setState({documents:response});
			}
		})
	}

	getServices(){
		fetch(Config.default.apiGateway.URL+'lookups?type=health_services&option=actives&order=true', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({facility_sections:response});
			}
		});
	}

	getPlasmaticProduct(){
		fetch(Config.default.apiGateway.URL+'plasmatic_product', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({plasmatic_products: response});
			}
		});
	}

	getPetition(petition){
		this.setState({petition_type:petition});

		this.setState({
			petition_episodio 	 :"",
			petition_location	 :"",
			petition_doctor		 :"",
			petition_observations:"",
			petition_diagnosis   :"",
			petition_reason 	 :"",
			products: [],
			plasmatic_product_id:"",
			health_facilities_name:"",
			health_services	  :"",
			maternal_test_ultima_regla	 	:"",
			maternal_test_gestational_week 	:"",
			maternal_test_gestational_day	:"",
			maternal_test_expected_birthday	:"",
			maternal_test_no_fetus		 	:"",
			maternal_test_profilaxis 		:"",
			maternal_test_profilaxis_date	:"",
			maternal_test_child_alive		:"",
			maternal_test_child_dead		:"",
			maternal_test_abortions		 	:""
		});
			

		this.removeValidation();
	}

	removeValidation(){
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		var control = document.getElementById(input.name);
	    		if(control !== null){
	    			control.classList.remove('error');
	    		}
	    		
		  	}
	    });
	}

	clearValues(){
		this.setState({
			petition_number	: "",
			petition_id: "",
			petition_episodio 	 :"",
			petition_ubication	 :"",
			petition_doctor		 :"",
			petition_observations:"",
			petition_diagnosis   :"",
			petition_reason 	 :"",

			plasmatic_products: [],
			plasmatic_product_id:"",
			plasmatic_product_amount:"",
			
			origin_center_id:"",

			health_services	  :"",
			
			maternal_test_ultima_regla	 	:"",
			maternal_test_gestational_week 	:"",
			maternal_test_gestational_day	:"",
			maternal_test_expected_birthday	:"",
			maternal_test_no_fetus		 	:"",
			maternal_test_profilaxis 		:"",
			maternal_test_profilaxis_date	:"",
			maternal_test_child_alive		:"",
			maternal_test_child_dead		:"",
			maternal_test_abortions		 	:"",

			petition_components:[],
			
			solicited_date: "",
			solicited_hour: "",

			previous_transfutions:[],
			previous_transfutions_name:"",
			petition_previal_transfution:"",

			petition_consentimiento:"",
			petition_component_priority:"",
			petition_component_surgery_type:"",

			analitical_profile_person_id:"",
			process_type:"", 
			solicitud_type:"",

			blood_component_type:"",
			blood_component_amount:"",
			componentsAdded:[],

			isLoading:false,
			analitical_list: [],
			list_test:[],
			test:"",
			profile:"",
		})	
	}

	getPetitionType(key){
		fetch(Config.default.apiGateway.URL+'petition_type/by_group_type?type='+key, {
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		}).then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
          	}
      	}).then(response => {
      		if(response !== undefined){
      			this.setState({
      				petitions:response
      			});
      			console.log(response)
      			/*if(this.props.match.params.id === undefined){
      				this.setState({
	      				petition_type: key === 'LABORATORY' ? "": response.res.length > 0 ? response.res[0].name : ''
	      			});
      			}*/
      		}
      	});
	}

	getAnaliticalTest(){
		fetch(Config.default.apiGateway.URL+'analitical_test?id=0&option=list', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: "Bearer "+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
 			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.test().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({analitical_list:response});
			}
		})
	}

	getAnaliticalProfile(){
		fetch(Config.default.apiGateway.URL+'analytic_profile_person?option=patients', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({profile_list:response});
			}
		});
	}
	
	setAnswers(items){
		items.map((item)=>{
			document.getElementById(item.campos_id).value = item.valor;
			document.getElementById(item.campos_id).disabled = true;
		});
	}

	handleTypeAheadChange = name => values => {
        if(values.length > 0){
        	if(name === 'product'){
        		this.setState({loading_product:true});

        		setTimeout(()=>{
        			this.setState({
						index_product:0,
						product_selected:values,
						plasmatic_product_amount:1,
						loading_product:false,
						plasmatic_product_id:values[0].id,
						valid_prod: ''
				    });

				    this._typeahead_product.getInstance().blur();
				    document.getElementById('plasmatic_product_amount').focus();

				    //this.errorAutoComplete('product');
        		}, 1000);
	        		
        	}else{
        		this.setState({
	    			isLoading:false,
		            [name]: values[0].id,
		            indice:0,
					requestedSelected:values,
		        });

				document.getElementById('health_services').focus();
        	}
	    		        	
        }
    }

    _handleSearch2 = (query) => {
	    this.setState({
	    	isLoading:true,
			indice:-1,
			requestedSelected:[],
	    });
	}

	handleChange(e){

	}

	onChangeTest = tipo => e => {
		if(e.length > 0){
			if(tipo === 'profile'){
				this.setState({
					analitical_profile_person_id: [...this.state.analitical_profile_person_id, e[0].profile.id],
					//list_test:[]
				});
				setTimeout(()=>{
					if(e[0].analytical_test_has_analytic_profile_donors.length > 0){
						var list = this.state.list_test;


						e[0].analytical_test_has_analytic_profile_donors.map((test)=>{
							var index = list.findIndex(obj => obj.id === test.id);

							if(index === -1){
								list.push({
									id: test.id,
									name: test.name,
									check: true
								})
							}								
							
						})

						this.setState({
							list_test: list,
							test:""
						});
					}
				}, 500)
					
			}else{
				this.setState({
					test: e[0]
				})
				
			}
		}
	}

	render(){
		const {t} = this.props;

		return (
			<Modal dialogClassName="modal-view" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Detalles</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
							<div className="col-xs-10">
								<fieldset className="col-xs-12">
									<legend>
										<a 
											href="#" 
											onClick={
												(e)=>{
													e.preventDefault(); 
													this.setState({hide_patient: this.state.hide_patient ? false : true});
												}
											}>
											Paciente
										</a>
									</legend>
									<div>
										<div className="col-xs-12">
											<div className="col-xs-12 col-sm-3">
												<span className="span-min">Nombre(s)</span>

												<input className="form-control" type="text" name="patient_name" id="patient_name" 
													value={this.state.patient_name || ""} 
												onKeyPress={(e) => this.props.validate(e)}
												onChange={this.handleChange} disabled={true}	/>
											</div>

											<div className="col-xs-12 col-sm-2">
												<span className="span-min">A. Paterno</span>

												<input className="form-control" type="text" name="patient_lastname1" id="patient_lastname1"
													value={this.state.patient_lastname1 || ""}
													onKeyPress={(e) => this.props.validate(e)} onChange={this.handleChange} 
													disabled={true} />
											</div>

											<div className="col-xs-12 col-sm-2">
												<span className="span-min">A. Materno</span>

												<input className="form-control" type="text" name="patient_lastname2" id="patient_lastname2" value={this.state.patient_lastname2 || ""}
													onKeyPress={(e) => this.props.validate(e)} onChange={this.handleChange} disabled={true} />
											</div>

											<div className="col-xs-12 col-sm-2">
												<span className="span-min">F. Nacimiento</span>

												<MaskedFormControl type='text' name="birthdate" id="birthdate" value={this.state.birthdate || ""}
													onChange={this.dateHandleChange} mask='11/11/1111' placeholder="dd/mm/yyyy" 
													onKeyPress={(e) => this.props.validate(e)}
													className="form-control" disabled={true}/>
											</div>

											<div className="col-xs-12 col-sm-1">
												<span className="span-min">
													<input type="checkbox" name="check_age" id="check_age" value={this.state.check_age} checked={this.state.check_age} 
														style={{marginRight:'5px'}} onChange={this.handleChange} disabled={true} />
													Edad
												</span>

												<input className="form-control" type="text" name="age" value={
													this.state.age === '0' ? '0' : this.state.age} 
													onKeyPress={(e) => this.props.validate(e)} onChange={this.handleChange}
													disabled={true ? true :	this.state.check_age ? false : true} />
											</div>

											<div className="col-xs-12 col-sm-2">
												<span className="span-min">Tipo</span>
												<select className="form-control" name="age_type" id="age_type" value={this.state.age_type} 
													onChange={this.handleChange} disabled={true ? true : this.state.check_age ? false : true}>
													<option value="DAYS">DIAS</option>
													<option value="MONTHS">MESES</option>
													<option value="YEARS">AÑOS</option>
												</select>
											</div>
										</div>

										<div className="col-xs-12">
											<div className="col-xs-12 col-sm-3">
												<span className="span-min">Tipo Documento</span>
												<select name="document_type" className="form-control" value={this.state.document_type || ""} 
													onKeyPress={(e) => this.props.validate(e)}
													onChange={this.handleChange} disabled={true}>
													<option value="">Seleccione...</option>
													{this.state.documents.map((d, i)=>{
														return <option key={i} value={d.key}>
															{d.name}
														</option>
													})}
												</select>
											</div>

											<div className="col-xs-12 col-sm-2">
												<span className="span-min">No. Doc.</span>
												<input className="form-control" type="text" name="document_number" 
													disabled={true} onKeyPress={(e) => this.props.validate(e)}
													value={this.state.document_number || ""} onChange={this.handleChange} />
											</div>

											<div className="col-xs-12 col-sm-2">
												<span className="span-min">F. Ultimo Envio</span>
												<input className="form-control" type="text" value={this.state.last_unit_date || ""} 
													disabled />
											</div>

											<div className="col-xs-12 col-sm-1" >
												<span className="span-min">{t('content.offers.form.gender')}</span>
												<select className="form-control" id="patient_sex" name="patient_sex"
													onKeyPress={(e) => this.props.validate(e)} disabled={true}
													onChange={this.handleChange}
													value={this.state.patient_sex} > 
													<option value="" >Seleccionar...</option>
													<option value="HOMBRE" >HOMBRE</option>
													<option value="MUJER" >MUJER</option>
												</select>
											</div>

											<div className="col-xs-12 col-sm-2">
												<span className="span-min" style={{fontSize:"11px"}}>No. IMSS</span>

												<input className="form-control" type="text" name="social_number" id="social_number"
													disabled={true} onKeyPress={(e) => this.props.validate(e)}
													value={this.state.social_number || ""} onChange={this.handleChange}/>
											</div>

											<div className="col-xs-12 col-sm-2">
												<span className="span-min">No. Expediente</span>

												<input className="form-control" type="text" name="clinic_history" id="clinic_history"
													disabled={true} onKeyPress={(e) => this.props.validate(e)}
													value={this.state.clinic_history || ""} onChange={this.handleChange} />
											</div>
										</div>

										<div className="col-xs-12">
											<div className="col-xs-12 col-sm-3">
												<span className="span-min">Tipo de Petición</span>
												<select className="form-control" name="petition" id="petition" 
													onKeyPress={(e) => this.props.validate(e)} disabled={true}
													value={this.state.petition || ""} onChange={this.handleChange} required>
													<option value="">Seleccione...</option>
													{this.state.type_petitions.map((p, i)=>{
														return <option key={i} value={p.key}>
															{p.name}
														</option>
													})}
												</select>
											</div>

											<div className="col-xs-12 col-sm-2">
												<span className="span-min">Unidades Reservadas</span>
												<input className="form-control" type="text" disabled 
													value={this.state.unit_reserved === "" ? '' : this.state.unit_reserved ? 'SI' : 'NO' } />
											</div>
										</div>
									</div>
								</fieldset>
							</div>
							<div className="col-xs-2">
								<div className="col-xs-12">
									<h1 style={{color:'red', textAlign:'center', fontSize:'5em'}}>
										{this.state.lookup_group}
										{this.state.lookup_rh === 'POSITIVO' ? '+':
										this.state.lookup_rh === 'NEGATIVO'     ? '-':''}
									</h1>
								</div>

								{this.state.lectina !== "" && this.state.lectina !== 'NO PROCESADO' ? 
									<div className="col-xs-12 col-sm-6">
										<span className="span-min" style={{fontSize:'1.5em'}}>Lectina: </span>
										<span style={{fontSize:'1em', marginLeft:'5px'}}>{this.state.lectina}</span>
									</div>
								: null }
								{this.state.du !== "" ? 
									<div className="col-xs-12 col-sm-6">
										<span className="span-min" style={{fontSize:'1.5em'}}>DU: </span>
										<span style={{fontSize:'1em', marginLeft:'5px'}}>{'('+this.state.du+')'}</span>
									</div>
								: null }

								{this.state.phenotypes !== "" ?
									<div className="col-xs-12 form-group">
										<span className="span-min" style={{fontSize:'1.5em'}}>Fenotipos: </span>
										<span style={{fontSize:'1em', display:'block' }}>{'('+this.state.phenotypes+')'}</span>
									</div>
								:null}
								{this.state.antibodys !== "" ?
									<div className="col-xs-12 form-group">
										<span className="span-min" style={{fontSize:'1.5em'}}>Anticuerpos: </span>
										<span style={{fontSize:'1em', display:'block' }}>{'('+this.state.antibodys+')'}</span>
									</div>
								:null}
							</div>
							<div className="col-xs-12">
								{this.state.petition !== "" ?
									<fieldset className="col-xs-12">
										<legend>{this.state.petition_type}</legend>


										<div className="col-xs-12">
											<div className="col-xs-12 col-sm-3">
												<span className="span-min">Petición</span>
												<select className="form-control" name="petition_type" id="petition_type" 
													value={this.state.petition_type} onKeyPress={(e) => this.props.validate(e)}
													onChange={this.handleChange} 
													disabled={true ? true :
																this.state.petition !== 'LABORATORY' ? true : false}>
													<option value="">Seleccione...</option>
													{this.state.petitions.map((p, i)=>(
														<option key={i} value={p.name}>{p.name}</option>
													))}
												</select>
											</div>

											{this.state.petition !== 'APHERESIS'?
												<div>
													<div className="col-xs-12 col-sm-2">
														<span className="span-min">Fecha</span>
														<input className="form-control hour-input" type="date" name="date" id="date" 
															value={this.state.date || ""} 
															onKeyPress={(e) => this.props.validate(e)} onChange={this.handleChange}  
															disabled={true ? true :
																this.state.pat_change_date_petition.value === 'NO' ? true : false
															}	
														/>
													</div>
													<div className="col-xs-12 col-sm-1">
														<span className="span-min">Hora</span>

														<input id="hour" name="hour" type="text" data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
															data-inputmask-placeholder="-" value={this.state.hour || ""} onKeyPress={(e) => this.props.validate(e)}
															className="form-control" onChange={this.handleChange}  
															disabled={true ? true :
																this.state.pat_change_date_petition.value === 'NO' ? true : false
															}
														/>
													</div>
											
													<div className="col-xs-12 col-sm-1">
														<span className="span-min" style={{fonSize:'12px'}}>No. Petición</span>

														<input className="form-control" type="text" name="petition_number" id="petition_number" onKeyPress={(e) => this.props.validate(e)}
															value={this.state.petition_number || ""} onChange={this.handleChange}  disabled={true} />
													</div>

													<div className={"col-xs-12 col-sm-1"} >
														<span className="span-min">Episodio</span>
														<input type="text" className="form-control" name="petition_episodio" id="petition_episodio" onKeyPress={(e) => this.props.validate(e)}
															value={this.state.petition_episodio || ""}  onChange={this.handleChange}  disabled={true} />
													</div>

													<div className="col-xs-12 col-sm-2">
														<span className="span-min">Prioridad</span>
														<select className="form-control" name="petition_component_priority" id="petition_component_priority"
															onKeyPress={(e) => this.props.validate(e)}  disabled={true}
															value={this.state.petition_component_priority || ""} 
															onChange={this.handleChange}
															style={{padding:"0 5px"}}>
															<option value="">Seleccione...</option>
															<option value="URGENTE">Urgente</option>
															<option value="24 HORAS">24 Horas</option>
															<option value="MEDIA">Media</option>
														</select>
													</div>

													{this.state.petition !== 'APHERESIS' ?
														<div>
															<div className="col-xs-12 col-sm-2">
																<span className="span-min">Sesión</span>
																<select required className="form-control" disabled value={ this.state.work_sessions_id } 
																	onChange={ this.handleChange } 
																	name="work_sessions_id" id="work_sessions_id">
																	{this.state.work_sessions.map(function(t) {
																		return <option  key={t.id}  value={t.id} >{t.type_value} </option>;
																	})}
																</select>
															</div>
														</div>
													:null}
												</div>
											:null}
										</div>

										<div className="col-xs-12">

											<div className="col-xs-12 col-sm-5">
												<span className="span-min">Origen</span>
												<AsyncTypeahead
													labelKey={(option) => `${option.name}`}
													minLength={0}
													inputProps={{
														name:"origin_center_id",
														disabled:true,
														id:"origin_center_id"
													}}
													disabled={true}
													id="originCenterId"
													options={this.state.health_facilities}
													onChange={this.handleTypeAheadChange('origin_center_id')}
													onSearch={this._handleSearch2}
													defaultSelected={this.state.health_facilities.slice(this.state.indice, 1)}
													selected={this.state.requestedSelected}
													ref={ref => this._typeahead_origin = ref}
													isLoading={this.state.isLoading}
													onKeyPress={(e) => this.props.validate(e)}
													useCache={false}
													delay={600}
													paginationText="Mostrar mas resultados..."
												/>
											
											</div>

											<div className="col-xs-12 col-sm-3">
												<span className="span-min">Servicio</span>
												<select className="form-control" name="health_services" id="health_services"
													onKeyPress={(e) => this.props.validate(e)}  disabled={true}
													value={this.state.health_services || ""} onChange={this.handleChange}>
													<option value="">Seleccione...</option>
													{this.state.facility_sections.map((f, i)=>{
														return <option key={i} value={f.key}>
															{f.name}
														</option>
													})}
												</select>
											</div>

											<div className="col-xs-12 col-sm-2">
												<span className="span-min">Ubicación</span>
												<input type="text" className="form-control" name="petition_ubication" id="petition_ubication" onKeyPress={(e) => this.props.validate(e)}
													value={this.state.petition_ubication || ""} onChange={this.handleChange}  disabled={true} />
											</div>


											{/*PETICION DE COMPONENTES}*/}
											{this.state.petition !== 'APHERESIS' ?
												<div>
													<div className="col-xs-12 col-sm-2">
														<span className="span-min">Cédula Médico</span>
														<input type="text" className="form-control" name="cedula_doctor" id="cedula_doctor" onKeyPress={(e) => this.props.validate(e)}
															value={this.state.cedula_doctor || ""} onChange={this.handleChange}  disabled={true} />
													</div>
												</div>
											:null}
										</div>

										{this.state.petition !== 'APHERESIS' ?
											<div className="col-xs-12">
												<div className="col-xs-12 col-sm-3">
													<span className="span-min">Médico</span>
													<input type="text" className="form-control" name="petition_doctor" id="petition_doctor" onKeyPress={(e) => this.props.validate(e)}
														value={this.state.petition_doctor || ""} onChange={this.handleChange}  disabled={true}
														style={{padding:'3px'}} />
												</div>

												<div className={this.state.petition_type.indexOf("MATERNO") === -1 ?
													"col-xs-12 col-sm-2" : "col-xs-12 col-sm-2"}>
													<span className="span-min">Previsto Para</span>
													<input className="form-control hour-input" type="date" name="solicited_date" id="solicited_date" onKeyPress={(e) => this.props.validate(e)}
														value={this.state.solicited_date || ""} onChange={this.handleChange}  disabled={true} />
												</div>
												{/*this.state.petition_type.indexOf("MATERNO") === -1 ?*/}
													<div className="col-xs-12 col-sm-1">
														<span className="span-min">Hora</span>
														<input id="solicited_hour" name="solicited_hour" id="solicited_hour" type="text"
															data-inputmask-alias="datetime"  data-inputmask-inputformat="HH:MM"  
															data-inputmask-placeholder="-" className="form-control"
															onKeyPress={(e) => this.props.validate(e)}  disabled={true}
															value={this.state.solicited_hour || ""}  onChange={this.handleChange} />
													</div>						
												{/*:null*/}
												
												<div className="col-xs-12 col-sm-2">
													<span className="span-min">Estatus</span>
													<input type="text" className="form-control" name="petition_status" id="petition_status" onKeyPress={(e) => this.props.validate(e)}
														value={this.state.petition_status || ""} onChange={this.handleChange}  disabled={true} />
												</div>

												<div className="col-xs-12 col-sm-2">
													<span className="span-min">Motivo</span>
													<select className="form-control" name="petition_reason" id="petition_reason" value={this.state.petition_reason || ""} 
														onKeyPress={(e) => this.props.validate(e)} onChange={this.handleChange}  disabled={true}>
														<option value="">Seleccione...</option>
														{this.state.reasons.map((r, i)=>{
															return <option key={i} value={r.key}>
																{r.name}
															</option>
														})}
													</select>
												</div>

												<div className="col-xs-12 col-sm-2">
													<span className="span-min">Tipo Cirugía</span>
													<select className="form-control" name="petition_component_surgery_type" id="petition_component_surgery_type"
														onKeyPress={(e) => this.props.validate(e)}  disabled={true}
														value={this.state.petition_component_surgery_type || ""} 
														onChange={this.handleChange}>
														<option value="">Seleccione...</option>
													</select>
												</div>

												
											</div>
											
										:null}

										<div className="col-xs-12">
											
											{this.state.petition === 'APHERESIS'?
												<div>
													<div className="col-xs-12 col-xs-5">
														<span className="span-min">Diagnóstico</span>
														{this.state.pat_diag_type.value === 'OPEN' ? 
															<input type="text" className="form-control" name="petition_diagnosis" id="petition_diagnosis"
																onKeyPress={(e) => this.props.validate(e)}  disabled={true}
																value={this.state.petition_diagnosis || ""} onChange={this.handleChange} />
														:<select className="form-control" value={this.state.petition_diagnosis} onChange={this.handleChange}
															disabled={true} name="petition_diagnosis" id="petition_diagnosis">
															<option value="">Seleccione...</option>
															{this.state.list_diagnosis.map((l, i)=>(
																<option key={i} value={l.Name}>{l.Name}</option>
															))}
														</select>}
														
													</div>
													<div className="col-xs-12 col-sm-2">
														<span className="span-min">Tipo de Proceso</span>
														<select className="form-control" name="process_type" id="process_type" 
															value={this.state.process_type || ""} onKeyPress={(e) => this.props.validate(e)} 
															onChange={this.handleChange}  disabled={true}>
															<option value="">Seleccione...</option>
															{this.state.petition_aferesis.map((a, i)=>{
																return <option key={i} value={a.key}>
																	{a.name}
																</option>
															})}
														</select>
													</div>
												</div>
											:null}
											
										</div>


										{this.state.petition === 'LABORATORY' && this.state.petition_type.indexOf("MATERNO") !== -1 ?
											<div >
												<div className="col-xs-12">
													{/*<div className="col-xs-12 col-sm-1">
														<span className="span-min">Hora</span>
														<input id="solicited_hour" name="solicited_hour" id="solicited_hour" type="text"
															data-inputmask-alias="datetime"  data-inputmask-inputformat="HH:MM"  
															data-inputmask-placeholder="-" className="form-control"
															onKeyPress={(e) => this.props.validate(e)}  disabled={true}
															value={this.state.solicited_hour || ""}  onChange={this.handleChange} />
													</div>*/}

													<div className="col-xs-12 col-sm-2">
														<span className="span-min">Ultima Regla</span>
														<input type="date" className="form-control hour-input" name="maternal_test_ultima_regla" id="maternal_test_ultima_regla"
															onKeyPress={(e) => this.props.validate(e)} disabled={true}
															value={this.state.maternal_test_ultima_regla || ""}
															onChange={this.handleChange} />
													</div>

													<div className="col-xs-12 col-sm-1">
														<span className="span-min" style={{fontSize:'10.5px'}}>Sem. Gestacional</span>
														<input type="text" className="form-control" name="maternal_test_gestational_week" id="maternal_test_gestational_week"
															onKeyPress={(e) => this.props.validate(e)} disabled={true}
															value={this.state.maternal_test_gestational_week || ""} 
															onChange={this.handleChange}/>
													</div>

													<div className="col-xs-12 col-sm-1">
														<span className="span-min">Día</span>
														<input type="text" className="form-control" name="maternal_test_gestational_day" id="maternal_test_gestational_day"
															onKeyPress={(e) => this.props.validate(e)} disabled={true}
															value={this.state.maternal_test_gestational_day || ""} 
															onChange={this.handleChange}/>
													</div>

													<div className="col-xs-12 col-sm-2">
														<span className="span-min">Parto Esperado</span>
														<input type="date" className="form-control hour-input" name="maternal_test_expected_birthday" id="maternal_test_expected_birthday"
															onKeyPress={(e) => this.props.validate(e)} disabled={true}
															value={this.state.maternal_test_expected_birthday || ""} 
															onChange={this.handleChange} />
													</div>

													<div className="col-xs-12 col-sm-1">
														<span className="span-min">No de Fetos</span>
														<input type="text" className="form-control" name="maternal_test_no_fetus" id="maternal_test_no_fetus"
															id="maternal_test_no_fetus"  onKeyPress={(e) => this.props.validate(e)}
															value={this.state.maternal_test_no_fetus || ""}  disabled={true}
															onChange={this.handleChange} />
													</div>
													

													<div className="col-xs-12 col-sm-1">
														<span className="span-min">Hijos Vivos</span>
														<input type="text" className="form-control" name="maternal_test_child_alive" id="maternal_test_child_alive"
															onKeyPress={(e) => this.props.validate(e)} disabled={true}
															value={this.state.maternal_test_child_alive || ""} onChange={this.handleChange}/>
													</div>

													<div className="col-xs-12 col-sm-2">
														<span className="span-min">Hijos Muertos</span>
														<input type="text" className="form-control" name="maternal_test_child_dead" id="maternal_test_child_dead"
															onKeyPress={(e) => this.props.validate(e)} disabled={true}
															value={this.state.maternal_test_child_dead || ""} onChange={this.handleChange} />
													</div>
													<div className="col-xs-12 col-sm-2">
														<span className="span-min">Abortos</span>
														<input type="text" className="form-control" name="maternal_test_abortions" id="maternal_test_abortions" 
															onKeyPress={(e) => this.props.validate(e)} disabled={true}
															value={this.state.maternal_test_abortions || ""} onChange={this.handleChange} />
													</div>
													
												</div>
												<div className="col-xs-12">
													<div className="col-xs-12 col-sm-1">
														<span className="span-min">Profilaxis</span>
														<select className="form-control" name="maternal_test_profilaxis" id="maternal_test_profilaxis"
															onChange={this.handleChange} onKeyPress={(e) => this.props.validate(e)}
															value={this.state.maternal_test_profilaxis || ""} disabled={true}>
															<option value="">Seleccione...</option>
															<option value="SI">SI</option>
															<option value="NO">NO</option>
														</select>
													</div>
													<div className="col-xs-12 col-sm-2">
														<span className="span-min">F. Profilaxis</span>
														<input type="date" className="form-control hour-input" name="maternal_test_profilaxis_date" id="maternal_test_profilaxis_date"
															onChange={this.handleChange} onKeyPress={(e) => this.props.validate(e)}
															disabled={this.state.maternal_test_profilaxis === "" || this.state.maternal_test_profilaxis === 'NO' || true}
															value={this.state.maternal_test_profilaxis_date || ""} />
													</div>
													
												</div>
											</div>
										:null}

										<div className="col-xs-12 form-group">
											{this.state.petition === 'COMPONENTS'?
												<div>
													<div className="col-xs-12 col-sm-5">
														<div className="col-xs-12" style={{padding:'0'}}>
															<span className="span-min">Diagnóstico</span>
															{this.state.pat_diag_type.value === 'OPEN' ? 
																<input type="text" className="form-control" name="petition_diagnosis" id="petition_diagnosis"
																	onKeyPress={(e) => this.props.validate(e)}  disabled={true}
																	value={this.state.petition_diagnosis || ""} onChange={this.handleChange} />
															:<select className="form-control" value={this.state.petition_diagnosis} onChange={this.handleChange}
																disabled={true} name="petition_diagnosis" id="petition_diagnosis">
																<option value="">Seleccione...</option>
																{this.state.list_diagnosis.map((l, i)=>(
																	<option key={i} value={l.Name}>{l.Name}</option>
																))}
															</select>}
															
														</div>
														<div className="col-xs-12 col-sm-7" style={{padding:'0'}}>
															<span className="span-min">Componente Sanguíneo</span>
															<select className="form-control" name="blood_component_type"
																id="blood_component_type"
																disabled={true}
																onKeyPress={(e) => this.props.validate(e)} 
																value={this.state.blood_component_type || ""} 
																onChange={this.handleChange}>
																<option value="">Seleccione...</option>
																{this.state.blood_components.map((c, i)=>{
																	return <option key={i} value={c.key}>
																		{c.name}
																	</option>
																})}
															</select>
														</div>

														<div className="col-xs-12 col-sm-4" style={{paddingLeft:"16px"}}>
															<span className="span-min">Cantidad</span>
															<input type="number" className="form-control hour-input" name="blood_component_amount" 
																id="blood_component_amount" disabled={true}
																onKeyPress={(e) => this.props.validate(e)}
																value={this.state.blood_component_amount || ""} 
																onChange={this.handleChange} />
														</div>
														<div className="col-xs-12 col-sm-1" style={{marginTop:"20px"}}>
															<FloatingActionButton className="action-btn" iconStyle={{height: 25, width: 25}} mini={true} 
																onClick={this.addComponent} disabled={true} >
															<ContentAdd/>
															</FloatingActionButton> 
														</div>
													</div>

													<div className="col-xs-12 col-sm-7">
														<span className="span-min">Observaciones</span>
														<span style={{fontSize:'10px', marginLeft:'5px'}}>{'Caracteres restantes : '+this.state.character_observa}</span>
														<textarea className="form-control" name="petition_observations" id="petition_observations"
															value={this.state.petition_observations || ""} style={{resize:"none"}} disabled={true}
															onKeyPress={(e) => this.props.validate(e)} onChange={this.handleChange} style={{height:"70px",width:"100%",resize:"none"}}>
														</textarea>
													</div>
													
												</div>
											:this.state.petition === 'LABORATORY'?
												<div>
													<div className="col-xs-12 col-sm-5">
														<div className="col-xs-12 col-sm-3" style={{paddingLeft:'0'}}>
															<span className="span-min">T. Solicitud</span>
															<select className="form-control" name="solicitud_type" id="solicitud_type" 
																value={this.state.solicitud_type} onChange={this.handleChange}
																disabled={true}>
																<option value="">Seleccione...</option>
																<option value="PRUEBA">PRUEBA</option>
																<option value="PERFIL">PERFIL</option>
															</select>
														</div>

														{this.state.solicitud_type !== 'PRUEBA' &&
														this.state.petition_type !== 'TRATAMIENTO CON PRODUCTOS PLASMÁTICOS' && 
														this.state.petition === 'LABORATORY' ?
															<div className="col-xs-12 col-sm-9">
																<span className="span-min">Seleccione Perfil</span>
																<Typeahead
																	labelKey={(option) => (`${option.profile.name}`)}
																	minLength={0}
																	options={this.state.profile_list.length > 0 ? this.state.profile_list : []}
																	onChange={this.onChangeTest('profile')}	
																	inputProps={{
																		name:"profile",
																		id:"profile"
																	}}
																	id="profile_test"
																	disabled={true || this.state.cant_change}
																	isLoading={this.state.isLoading}
																	useCache={false}
																	ref={ref => this._typeahead_profile = ref}
																	defaultSelected={this.state.profile_list.slice(this.state.index_profile, 1)}
																	selected={this.state.profile_selected}
																	delay={600}
																	paginationText="Mostrar mas resultados..."
																/>
															</div>
														: this.state.solicitud_type === 'PRUEBA' && 
														this.state.petition === 'LABORATORY'? 
															<div>
																<div className="col-xs-12 col-sm-7">
																	<span className="span-min">Seleccione Prueba</span>
																	
																	<Typeahead
																		labelKey={(option) => (`${option.analitical_test.name}`)}
																		minLength={0}
																		options={this.state.analitical_list.length > 0 ? this.state.analitical_list : []}
																		onChange={this.onChangeTest('test')}	
																		inputProps={{
																			name:"test",
																			id:"test"
																		}}
																		id="test_text"
																		disabled={true}
																		isLoading={this.state.isLoading}
																		ref={ref => this._typeahead_test = ref}
																		useCache={false}
																		delay={600}
																		paginationText="Mostrar mas resultados..."
																	/>
																</div>
																<div className="col-xs-12 col-sm-1" style={{marginTop:"20px"}}>

																	<FloatingActionButton className="action-btn"  mini={true} 
																		iconStyle={{height: 25, width: 25}}
																		disabled={true}
																	>

																	<ContentAdd/>
																	</FloatingActionButton> 
																</div>
															</div>
														:null}

													</div>

													<div className="col-xs-12 col-sm-7">
														<span className="span-min">Observaciones</span>
														<span style={{fontSize:'10px', marginLeft:'5px'}}>{'Caracteres restantes : '+this.state.character_observa}</span>
														<textarea className="form-control" name="petition_observations" id="petition_observations"
															value={this.state.petition_observations || ""} style={{resize:"none"}} disabled={true}
															onKeyPress={(e) => this.props.validate(e)} onChange={this.handleChange} style={{height:"70px",width:"100%",resize:"none"}}>
														</textarea>
													</div>
												
												</div>
											:this.state.petition === 'PLASMATIC_PRODUCTS' ?
												<div>
													<div className="col-xs-12 col-sm-5" style={{paddingLeft: "0px"}}>
														<div className="col-xs-12" style={{paddingRight: "0px"}}>
															<span className="span-min">Diagnóstico</span>
															{this.state.pat_diag_type.value === 'OPEN' ? 
																<input type="text" className="form-control" name="petition_diagnosis" id="petition_diagnosis"
																	onKeyPress={(e) => this.props.validate(e)}  disabled={true}
																	value={this.state.petition_diagnosis || ""} onChange={this.handleChange} />
															:<select className="form-control" value={this.state.petition_diagnosis} onChange={this.handleChange}
																disabled={true} name="petition_diagnosis" id="petition_diagnosis">
																<option value="">Seleccione...</option>
																{this.state.list_diagnosis.map((l, i)=>(
																	<option key={i} value={l.Name}>{l.Name}</option>
																))}
															</select>}
															
														</div>
														<div>
															<div className="col-xs-12 col-sm-7" style={{paddingRight: "3px"}}>
																<span className="span-min">Producto Hemostáticos</span>
															
																<Typeahead
																	labelKey={(option) => (`${option.name}`)}
																	minLength={0}
																	options={this.state.plasmatic_products.length > 0 ? this.state.plasmatic_products : []}
																	onChange={this.handleTypeAheadChange('product')}	
																	inputProps={{
																		name:"product",
																		id:"product",
																		autoComplete:"off",
																	}}
																	disabled={true}
																	id="auto_product"
																	isLoading={this.state.loading_product}
																	useCache={false}
																	ref={ref => this._typeahead_product = ref}
																	defaultSelected={this.state.plasmatic_products.slice(this.state.index_product, 1)}
																	selected={this.state.product_selected}
																	selectHintOnEnter={true}
																	delay={600}
																	paginationText="Mostrar mas resultados..."
																/>


															</div>
															<div className="col-xs-12 col-sm-4" style={{paddingLeft: "11px"}}>
																<span className="span-min">Cantidad</span>
																<input type="text" className="form-control" name="plasmatic_product_amount" 
																	id="plasmatic_product_amount"
																	disabled={true}
																	value={this.state.plasmatic_product_amount} onChange={this.handleChange} />
															</div>
															<div className="col-xs-12 col-sm-1" style={{marginTop:"20px"}}>
																<FloatingActionButton className="action-btn" iconStyle={{height: 25, width: 25}} mini={true} 
																	onClick={this.addPlasmatic} disabled={true} >
																<ContentAdd/>
																</FloatingActionButton> 
															</div>
														</div>
													</div>
													
													<div className="col-xs-12 col-sm-7">
														<span className="span-min">Observaciones</span>
														<span style={{fontSize:'10px', marginLeft:'5px'}}>{'Caracteres restantes : '+this.state.character_observa}</span>
														<textarea className="form-control" name="petition_observations" id="petition_observations" 
															value={this.state.petition_observations || ""} style={{height: '70px', width: '100%', resize: 'none'}}
															onChange={this.handleChange} disabled={true}>
														</textarea>
													</div>
												</div>
											: <div className="col-xs-12 col-sm-5">
												<span className="span-min">Observaciones</span>
												<span style={{fontSize:'10px', marginLeft:'5px'}}>{'Caracteres restantes : '+this.state.character_observa}</span>
												<textarea className="form-control" name="petition_observations" id="petition_observations"
													value={this.state.petition_observations || ""} style={{resize:"none"}} disabled={true}
													onKeyPress={(e) => this.props.validate(e)} onChange={this.handleChange} style={{height:"70px",width:"100%",resize:"none"}}>
												</textarea>
											</div>}									
										</div>

										<div className="col-xs-12">
											{this.state.petition === 'COMPONENTS' ?
												<div className="col-xs-12 col-sm-5">
													<Table>
														<thead>
															<tr>
																<th>Componente Sanguíneo</th>
																<th>Cantidad</th>
																<th></th>
															</tr>
														</thead>
														<tbody>
															{this.state.petition_components.map((p, i)=>{
																return <tr key={i}>
																	<td>{p.component_type.replace('_', ' ')}</td>
																	<td>{p.amount}</td>
																	<td>
																		<button className="btn btn-info btn-xs" title="Eliminar" 
																			style={{marginRight:'3px'}} 
																			disabled={true}
																			onClick={() =>  this.removeFromList(i)}>
																			<SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
																		</button>
																	</td>
																</tr>
															})}
														</tbody>
													</Table>
												</div>
											:this.state.petition === 'LABORATORY' ?
												<div className="col-xs-12 col-sm-5">
													<Table>
														<thead>
															<tr>
																<th></th>
																<th>Pruebas Asignadas</th>
															</tr>
														</thead>
														<tbody>
															{this.state.list_test.map((list, i)=>{
																return <tr key={i}>
																	<td>
																		<input type="checkbox" id={"test_"+list.id} checked={list.check} 
																			onChange={this.checked} disabled={true}/>
																	</td>
																	<td>{list.name}</td>
																</tr>
															})}
														</tbody>
													</Table>
												</div>
											
											:this.state.petition === 'PLASMATIC_PRODUCTS' ?
												<div className="col-xs-12 col-sm-5">
													<table className="table">
														<thead>
															<tr>
																<th>Producto Hemostáticos</th>
																<th>Cantidad</th>
															</tr>
														</thead>
														<tbody>
															{this.state.plasmaticAdded.map((p, i)=>(
																<tr key={i}>
																	<td>{p.name}</td>
																	<td>{p.amount}</td>
																</tr>
															))}
														</tbody>
													</table>
												</div>
											:null}		

											
											<div className="col-xs-12 col-sm-5">
												<div className="col-xs-12 col-sm-8" style={{marginTop:'10px'}}>
													{this.state.pat_pol_trans === 'YES' ?
														<div>
															<input type="checkbox" name="politransfused" id="politransfused"
																onChange={this.handleChange} 
																checked={this.state.politransfused} 
																disabled={true}
																style={{marginRight:"5px"}}/>
															<span className="span-min">Politransfundido</span>
														</div>
													:null}
													<div>
														<input type="checkbox" name="petition_previal_transfution" id="petition_previal_transfution"
															style={{marginRight:"5px"}} onChange={this.handleChange} disabled={true}/>
														<span className="span-min">Transfusiones Previas</span>
													</div>
													<div>
														<input type="checkbox" name="petition_consentimiento" id="petition_consentimiento"
															style={{marginRight:"5px"}} onChange={this.handleChange} disabled={true}/>
														<span className="span-min">Consentimiento Informado</span>
													</div>
												</div>
												{this.state.politransfused ? 
													<div className="col-xs-12 col-sm-4" style={{marginTop:'10px'}}>
														<input type="number" className="form-control hour-input" disabled={true}/>
													</div>
												:null}
												
											</div>
											
										</div>
									</fieldset>
								:null}

								<div className="col-xs-12">
									{this.state.list_components.length > 0 ?
										<Table responsive hover>
											<thead>
												<tr>
													<th>Componente</th>
													<th>Unidad Reservada</th>
													<th>Fecha Reserva</th>
													<th></th>
													<th>Unidad Enviada</th>
													<th>Fecha Envío</th>
													<th></th>
													<th>Unidad Devuelta</th>
													<th>Fecha Devolución</th>
													<th>Destino</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												{this.state.list_components.map((list, i)=>(
													<tr key={i}>
														<td>{list.component}</td>
														<td>{list.unit_reserved_number}</td>
														<td>{list.reserved_date !== null ? moment(list.reserved_date).format('DD/MM/YYYY') : ""}</td>
														<td>
															{this.props.task_unit_reserves.delete ?
																list.unit_delivered_id === null && list.reserved_id !== null?
																	<button className="btn btn-info" 
																		onClick={(e)=>this.deleteProcess(e, list, 'Reserva')}	>
																		<SvgIcon size={15} icon={bin} />
																	</button>
																:null
															:null}												
														</td>
														<td>{list.unit_delivered_number}</td>
														<td>{list.delivered_date !== null ? moment(list.delivered_date).format('DD/MM/YYYY HH:mm') : ""}</td>
														<td>
															{this.props.task_unit_delivered.delete ? 
																list.unit_delivered_id !== null && list.returns_id === null?
																	<button className="btn btn-info"
																		onClick={(e)=>this.deleteProcess(e, list, 'Envío')}	>
																		<SvgIcon size={15} icon={bin} />
																	</button>
																:null
															:null}												
														</td>
														<td>{list.unit_return_number}</td>
														<td>{list.return_date !== null ? moment(list.return_date).format('DD/MM/YYYY HH:mm') : ""}</td>
														<td>{list.destiny}</td>
														<td>
															{list.returns_id !== null ? 
																this.props.task_has_user_profiles.map((t)=>(
																	t.type === 'CANCEL_RETURNS_DELIVERY' ? 
																		<button className="btn btn-info" 
																			onClick={(e)=>this.deleteProcess(e, list, 'Devolución')}	>
																			<SvgIcon size={15} icon={bin} />
																		</button>
																	:null
																))															
															:null}												
														</td>
													</tr>
												))}
											</tbody>
										</Table>
									:null}
								</div>
							</div>


							<div className="col-xs-12">
								

								{this.state.list_unit_reserved.length > 0 ?
									<fieldset className="col-xs-12 form-group">
										<legend>Unidades Reservadas</legend>
										<Table hover>
											<thead>
												<tr>
													<th>Componente</th>
													<th>Cantidad</th>
												</tr>
											</thead>
											<tbody>
												{this.state.list_unit_reserved.map((u, i)=>(
													<tr key={i}>
														<td>{u.component}</td>
														<td>{u.amount}</td>
													</tr>
												))}
											</tbody>
										</Table>
									</fieldset>
								:null}

								{this.state.list_unit_delivered.length > 0 ?
									<fieldset className="col-xs-12 form-group">
										<legend>Unidades Enviadas</legend>
										<Table hover>
											<thead>
												<tr>
													<th>Componente</th>
													<th>Cantidad</th>
												</tr>
											</thead>
											<tbody>
												{this.state.list_unit_delivered.map((u, i)=>(
													<tr key={i}>
														<td>{u.component}</td>
														<td>{u.amount}</td>
													</tr>
												))}
											</tbody>
										</Table>
									</fieldset>
								:null}

								{this.state.last_date_send !== "" ?
									<div className="col-xs-12 form-group">
										<span className="span-min" style={{fontSize:'1.5em'}}>Fecha de último envío: </span>
										<span style={{fontSize:'1em', marginLeft:'5px' }}>{'('+this.state.last_date_send+')'}</span>
									</div>
								:null}

							</div>

		        		</div>
		        		<Notifications />
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>
		)
	}
}
export default translate('translations') (ModalInfo);